import { createContext, CSSProperties, ReactNode, useContext } from "react";
import styles from "./radio-button.module.css";

const RadioGroupContext = createContext<{
  name: string;
  onChange: (value: string) => void;
}>({
  name: "",
  onChange: () => {},
});

const useRadioGroupContext = () => {
  const context = useContext(RadioGroupContext);
  if (!context) {
    throw new Error("RadioButton must be used within a RadioButtonGroup");
  }
  return context;
};

export const RadioButton = ({
  value,
  initialChecked,
  label,
}: {
  value: string;
  initialChecked?: boolean;
  label: ReactNode;
}) => {
  const { name, onChange: onChangeGroup } = useRadioGroupContext();

  return (
    <label className={styles.customRadio}>
      <input
        type="radio"
        name={name}
        value={value}
        onChange={() => onChangeGroup(value)}
        defaultChecked={initialChecked}
      />
      {label}
    </label>
  );
};

export const RadioButtonGroup = ({
  children,
  name,
  onChange,
  classes,
}: {
  children: React.ReactNode;
  name: string;
  onChange: (value: string) => void;
  classes?: {
    group?: CSSProperties;
  };
}) => {
  return (
    <RadioGroupContext.Provider value={{ name, onChange }}>
      <div className={styles.radioButtonGroup} style={classes?.group ?? {}}>
        {children}
      </div>
    </RadioGroupContext.Provider>
  );
};
